import { createContext, useCallback, useContext } from 'react';
import { useTrainingStore } from '~/training/state';

const SequenceAnswersContext = createContext<string | undefined>(undefined);
export const SequenceAnswersProvider = SequenceAnswersContext.Provider;

export const useSaveQuestionAnswers = () => {
  const chapterSequenceId = useContext(SequenceAnswersContext);
  const save = useTrainingStore(s => s.saveQuestionAnswers);

  return useCallback(
    (questionFieldId: string) => {
      if (chapterSequenceId) save(questionFieldId, chapterSequenceId);
    },
    [save, chapterSequenceId]
  );
};
